import PlansPT from "../pages/images/plans/plansPT.pdf";
import PlansIT from "../pages/images/plans/plansIT.pdf";
import PlansES from "../pages/images/plans/plansES.pdf";

export const plans = {
  pt: PlansPT,
  es: PlansES,
  it: PlansIT,
};
